import { PersistStorage } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';
import { CustomerWebSiteAppInitResponse } from '@shory-health-individual/customer-api';
import sharedMiddlewares from '../shared-middlewares';

type State = CustomerWebSiteAppInitResponse & {
	appInitLoading: boolean;
};
type Actions = {
	setAppInit: (data: CustomerWebSiteAppInitResponse) => void;
	setAppInitLoading: (appInitLoading: boolean) => void;
};

export type Store = State & Actions;

export type AppInitStoreOptions = {
	devtoolsEnabled: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	storage: PersistStorage<any> | undefined;
};

export type AppStateSelector<K extends keyof Store> = (store: Store) => Store[K];

const initialState: State = {
	appInitLoading: true,
	benefitCategories: [],
	benefits: [],
	countries: [],
	currencies: [],
	emirates: [],
	facilityTypes: [],
	genders: [],
	insuranceCompanies: [],
	maritalStatuses: [],
	networkGroups: [],
	paymentConfig: [],
	planExclusions: [],
	plans: [],
	planTypes: [],
	policyTypes: [],
	relationships: [],
	salaryBands: [],
	userAcknowledgements: [],
	userAcknowledgementTypes: [],
	vatConfigurations: [],
	systemConfigurationSettings: {
		documentRefreshIntervalTimeInInMilliSeconds: 0,
		documentRefreshTimeOutInMilliSeconds: 0,
		apiTimeOutInSeconds: 0,
		uploadDocumentMaxSizeInKB: 0,
		maxAgeAllowed: 0,
		policyEffectiveDateThreshold: 0,
		policyEndDateCutoff: 0,
		newBornSettings: {
			maxHeight: 0,
			maxNumberOfDays: 0,
			maxWeight: 0,
			minHeight: 0,
			minWeight: 0,
		},
		maximumNoOfMember: 0,
		maximumChildrenCount: 0,
		maximumSpouseCount: 0,
		abuDhabiHealthInsurancePaymentUrl: '',
		paymentVendorMethodConfigurations: [],
		telrPaymentApplePayTestModeEnabled: false,
		telrPaymentApplePayTestAccount: '',
	},
	uploadedDocumentConfigs: [],
	occupations: [],
};

export const createInitStore = ({ devtoolsEnabled, storage }: AppInitStoreOptions) =>
	createStore<Store>()(
		sharedMiddlewares(
			(set) => ({
				...initialState,
				setAppInit: (data) => set({ ...data, appInitLoading: false }),
				setAppInitLoading: (appInitLoading) => set({ appInitLoading }),
			}),
			{ name: 'app-init', devtoolsEnabled, storage }
		)
	);
